import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      width: '100%',
      borderRadius: '5px',
      padding: '1.6rem',
      border: '1px solid #ABABAB',

      '& .MuiTypography-h4': {
        padding: '0.5rem 0 2rem 0',
      },
      '& .MuiFormControl-root': {
        width: '100%',
        margin: 0,
      },

      '& .MuiInputBase-root': {
        '& input': {
          cursor: 'pointer',
        },
      },
    },
    btn: {
      width: '10rem',
      margin: '2rem 0 0 0',
    },
  }),
)
